import { UserType } from 'src/app/user-roles';
import { MenuCategory } from '../../services/menu/types';

export const adminMenuItems: MenuCategory[] = [
  {
    items: [
      {
        label: 'BACK_TO_DASHBOARD',
        route: '/',
        icon: 'arrow_back',
        exactMatch: true
      }
    ]
  },
  {
    label: 'MANAGE',
    items: [
      {
        label: 'PAYOUTS',
        route: '/admin/payouts',
        icon: 'attach_money'
      },
      {
        label: 'OPERATORS',
        route: '/admin/operators',
        icon: 'headset_mic'
      },
      {
        label: 'INSTALLERS',
        route: '/admin/installers',
        icon: 'engineering'
      },
      {
        label: 'OPERATOR_PACKAGES',
        route: '/admin/operator-packages',
        icon: 'shopping_cart'
      },
      {
        label: 'MANUFACTURERS',
        route: '/admin/manufacturers',
        icon: 'factory'
      },
      {
        label: 'ROAMING_PLATFORMS',
        route: '/admin/roaming-platforms',
        icon: 'language'
      },
      {
        label: 'BOX_MODELS',
        route: '/admin/box-models',
        icon: 'ev_station'
      },
      {
        label: 'Vendor errors',
        route: '/admin/vendor-erros',
        icon: 'error'
      },
      {
        label: 'Accounting',
        route: '/admin/accounting',
        roles: UserType.SuperUser,
        icon: 'payments'
      },
      {
        label: 'SUPPORT_LINKS',
        route: '/admin/helpdesk',
        icon: 'link'
      },
      {
        label: 'PAYMENT_TERMINALS',
        route: '/admin/terminals',
        icon: 'point_of_sale'
      }
    ]
  },
  {
    label: 'CONTROL',
    items: [
      {
        label: 'API_CALLER',
        route: '/admin/api-caller',
        icon: 'api'
      },
      {
        label: 'COMMAND_RESPONSES',
        route: '/admin/command-responses',
        icon: 'checklist'
      },
      {
        label: 'WEB_BACKEND',
        route: '/admin/web-backend/websocket-connections',
        icon: 'cloud'
      }
    ]
  },
  {
    label: 'REPORTS',
    items: [
      {
        label: 'LOCATION_USAGE',
        route: '/admin/station-usage',
        icon: 'receipt_long'
      }
    ]
  },
  {
    label: 'LOGS',
    items: [
      {
        label: 'CHANGELOG',
        route: '/admin/changelog',
        icon: 'list_alt'
      },
      {
        label: 'ERROR_LOGS',
        route: '/admin/error-log',
        roles: UserType.DeveloperCurrent,
        icon: 'assignment_late'
      },
      {
        label: 'SMS_ACTIVITY',
        route: '/admin/sms-logs',
        icon: 'send_to_mobile'
      },
      {
        label: 'PUSH_ACTIVITY',
        route: '/admin/push-notification-logs',
        icon: 'ad_units'
      },
      {
        label: 'LOGIN_ATTEMPTS',
        route: '/admin/login-attempts',
        icon: 'password'
      }
    ]
  }
];
